import { InjectionToken, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TmWowDirective } from './wow.directive';

export const WOW_ASSETS = new InjectionToken<{ scripts: string[]; styles: string[]; }>('WOW_ASSETS');
export const wowAssetsDefaultConfig = {
  scripts: ['/assets/wow/wow.min.js'],
  styles: ['/assets/animate/animate.min.css']
};


/**
 * [WOW](https://wowjs.uk/docs.html) 包裝模組，
 * 在引用套件的模組提供 WOW_ASSETS 這個依賴項目
 * ```typescript
 * {provide: WOW_ASSETS, useValue: {
 *   scripts: ['/assets/wow/wow.min.js'],
 *   styles:  ['/assets/animate/animate.min.css']
 * }}
 * ```
 */
@NgModule({
  declarations: [
    TmWowDirective,
  ],
  imports: [
    CommonModule,
    FormsModule,
  ],
  exports: [
    TmWowDirective,
  ]
})
export class TmWowModule {}
